import React from "react";

function ActivityIcons() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="61"
      fill="none"
      viewBox="0 0 60 61"
    >
      <path
        fill="#89C35C"
        fillOpacity="0.7"
        d="M31.035 0C22.804 0 14.91 3.488 9.09 9.696S0 24.324 0 33.103H7.76c0-3.26.602-6.488 1.772-9.5a25 25 0 015.045-8.055c4.365-4.656 10.285-7.272 16.459-7.272"
      ></path>
      <circle cx="37.724" cy="38.724" r="21.724" fill="#FFDB00"></circle>
    </svg>
  );
}

export default ActivityIcons;